import { Profile } from 'oidc-client';
import type { Key } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParams } from '../../../core/models/RouteHelper';
import { CompetitionVm } from '../../../utils/api';
import CompetitionTable from './CompetitionTable';

interface OwnProps {
    userProfile: Profile;
    wrappedComponentRef?: any;
    competitionsFromProps?: CompetitionVm[];
    /** Step 1 of batch add season: row checkboxes */
    batchSelectionMode?: boolean;
    batchSelectedRowKeys?: Key[];
    onBatchSelectedRowKeysChange?: (keys: Key[]) => void;
}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(CompetitionTable);
